import {
    getMessages,
    getMessagesDailyStats,
    getMessagesStats,
    removeMessage,
    setMessageFeedback,
    toggleFavorite,
} from './agent';

import type {
    IMessagesRequest,
    IMessagesResponse,
    IMessagesStatsResponse,
    IMessagesDailyStatsResponse,
    MessageLeadFeedback,
} from 'src/types/Message';

class MessagesService {
    fetchMessages = async (params: IMessagesRequest): Promise<IMessagesResponse> => {
        try {
            const { data } = await getMessages(params);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    fetchMessagesStats = async (
        params: Omit<IMessagesRequest, 'limit' | 'offset'>
    ): Promise<IMessagesStatsResponse> => {
        try {
            const { data } = await getMessagesStats(params);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    fetchMessagesDailyStats = async (params: {
        from: string;
        to: string;
        relevant_only?: boolean;
        bundles?: string;
        chat_ids?: string;
        keywords?: string;
    }): Promise<IMessagesDailyStatsResponse> => {
        try {
            const { data } = await getMessagesDailyStats(params);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    toggleFavoriteMessage = async (id: number, flag: boolean) => {
        try {
            const { status } = await toggleFavorite(id, flag);

            if (status === 200) {
                return Promise.resolve({});
            }

            throw new Error(`Неудалось ${flag ? 'добавить в избранное' : 'удалить из избранного'}`);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    saveMessageFeedback = async (id: number, feedback: MessageLeadFeedback): Promise<MessageLeadFeedback> => {
        try {
            const { data, status } = await setMessageFeedback(id, feedback);

            if (status === 200) {
                return Promise.resolve(data.feedback ?? null);
            }

            throw new Error('Не удалось сохранить оценку лида');
        } catch (error) {
            return Promise.reject(error);
        }
    };

    removeMessage = async (id: number) => {
        try {
            const { status } = await removeMessage(id);

            if (status === 200) {
                return Promise.resolve({});
            }

            throw new Error('Сообщение не найдено или вы не имеете прав на его удаление.');
        } catch (error) {
            return Promise.reject(error);
        }
    };
}

export default new MessagesService();
